import { Loadable, OrderResponseMessage, ResponseMessageType } from '@eih-netbroker/common';
import { useEffect, useMemo } from 'react';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { FeedbackBox } from '../../../../shared/components/feedback-box/FeedbackBox';
import { useOrderCurrencyExchangeState } from '../OrderCurrencyExchangeStateContext';
import classes from './OrderWarningConfirm.module.scss';

interface OrderWarningConfirmProps {
  messages: OrderResponseMessage[];
}

type MessagesByType = Record<ResponseMessageType, string[]>;

export const OrderWarningConfirm = ({ messages }: OrderWarningConfirmProps) => {
  const { setExchangeRate } = useOrderCurrencyExchangeState();
  const { translateWithParams, translation } = useLocale();
  const mappedMessage = useMemo(
    () =>
      messages.reduce(
        (prev: MessagesByType, curr) => {
          // confirm messages are displayed as warnings
          if (curr.msgType === 'confirm') {
            prev['warn'].push(curr.msg!);
          } else {
            prev[curr.msgType!].push(curr.msg!);
          }

          return prev;
        },
        {
          info: [],
          warn: [],
          error: [],
          confirm: [],
        },
      ),
    [messages],
  );

  useEffect(() => {
    if (mappedMessage.error.length > 0) {
      setExchangeRate(Loadable.uninitialized);
    }
  }, [mappedMessage, setExchangeRate]);

  if (mappedMessage.error.length > 0) {
    return (
      <div className={classes.container}>
        <FeedbackBox
          title={translateWithParams(translation.orderModal.orderWarningConfirm.errorTitle, {
            messageNumber: mappedMessage.error.length.toString(),
          })}
          details={mappedMessage.error}
          type={'error'}
        />
      </div>
    );
  }

  if (mappedMessage.warn.length > 0) {
    return (
      <div className={classes.container}>
        <FeedbackBox
          title={translateWithParams(translation.orderModal.orderWarningConfirm.warnTitle, {
            messageNumber: mappedMessage.warn.length.toString(),
          })}
          details={mappedMessage.warn}
          backgroundBold={false}
          type={'warning'}
        />
      </div>
    );
  }

  return <div />;
};
